import '../styles/global.scss';
import { mount } from 'svelte';
import Frontend from './Frontend.svelte';
import { ModeService } from './services/ModeService.svelte';

// - DarkMode|LightMode
const Mode = new ModeService();
Mode.init();

// - Create frontend
const target = document.getElementById('frontend');
if (target === null) {
    throw new Error('Frontend target element not found.');
}
export default mount(Frontend, { target });
